import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "calendar-check, date-check" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M5.16667 3.16536H3.83333C3.09695 3.16536 2.5 3.76232 2.5 4.4987V6.16536M5.16667 3.16536H10.8333M5.16667 3.16536V1.83203M10.8333 3.16536H12.1667C12.903 3.16536 13.5 3.76232 13.5 4.4987V6.16536M10.8333 3.16536V1.83203M7.5 13.4987H3.83333C3.09695 13.4987 2.5 12.9017 2.5 12.1654V6.16536M2.5 6.16536H13.5M13.5 6.16536V8.16536M14.1667 10.4987L11.2778 14.1654L9.83333 12.6987",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }